import fetchApi from "../fetchApi";
export const getGiftReceipt = async (
    {id, type = "regular", prn = "", ids=""}
   ) => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/${id}/${type}/gift-receipt?prn=${prn}&ids=${ids}`, options);
};